import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api as missionStorageApi } from '../app/services/missionStorageApi';
import { missionSchedulerApi } from '../app/services/missionSchedulerApi';
import { behaviourRulesApi } from '../app/services/behaviourRulesApi';
import missionCreationReducer from './missionCreationSlice';
import arcProxyReducer from './arcProxySlice';

export const store = configureStore({
  reducer: {
    [missionStorageApi.reducerPath]: missionStorageApi.reducer,
    [missionSchedulerApi.reducerPath]: missionSchedulerApi.reducer,
    [behaviourRulesApi.reducerPath]: behaviourRulesApi.reducer,
    missionCreation: missionCreationReducer,
    arcProxy: arcProxyReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      missionStorageApi.middleware,
      missionSchedulerApi.middleware,
      behaviourRulesApi.middleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
